export const CHECK_FIELDS = [
  "status",
  "price",
  "size",
  "capacity",
  "photos",
] as const;

export type CheckField = (typeof CHECK_FIELDS)[number];

/**
 * Maps CHECK_FIELDS keys to the corresponding field name inside the entity's
 * metadata object (entity.metadata.<key>). Needed because the checkFieldsUpdates
 * keys ("price", "size") differ from the entity metadata field names
 * ("monthlyPrice", "sizeM2").
 */
export const CHECK_FIELD_TO_METADATA_KEY: Record<CheckField, string> = {
  status: "status",
  price: "monthlyPrice",
  size: "sizeM2",
  capacity: "capacity",
  photos: "photos",
};
